var React = require('react');

function W1 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"W1"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("polygon",{"points":"38.09 81.46 54 41.81 69.9 2.16 34.95 3.97 0 5.79 19.05 43.63 38.09 81.46","fill":"#e5c83d","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("polygon",{"points":"64.68 2.43 48.23 45.32 71.42 77.79 101.72 0 64.68 2.43","fill":"#73c9bd","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

W1.defaultProps = {"viewBox":"0 0 101.72 81.46"};

module.exports = W1;

W1.default = W1;
